/*eslint-disable */

export const USER_INITIAL_STATE = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    groups: [],
}

export const CREATE_FORM_FIELDS_CONFIG = {
    showDomainName: true,
}

export const DISABLED_BULK_FOR_TENANTS = ['GlobalInnovMed'];